module.exports = __webpack_public_path__ + "img/接受站.e3edcb13.png";